<div class="user-roles">
    <div class="text-muted" *ngIf="!loaded"><i class="fa fa-spinner fa-spin"></i> Chargement...</div>
    <div class="text-muted" *ngIf="loaded && noAccount">Aucun compte utilisateur associé à cet email.</div>

    <ng-container *ngIf="loaded && !noAccount">
      <div class="alert alert-danger py-2" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="user-roles__list">
        <span class="text-muted" *ngIf="userRoles.length === 0">Aucun rôle attribué</span>
        <span class="badge badge-info user-roles__badge" *ngFor="let role of userRoles">
          {{ label(role) }}
          <button type="button" class="user-roles__remove" *ngIf="canManage(role)"
                  (click)="removeRole(role)" [disabled]="loadingRole !== null" title="Retirer ce rôle">
            <span *ngIf="loadingRole === role" class="spinner-border spinner-border-sm"></span>
            <span *ngIf="loadingRole !== role">&times;</span>
          </button>
        </span>
      </div>

      <div class="user-roles__add" *ngIf="availableRoles.length > 0">
        <span class="user-roles__add-label">Ajouter :</span>
        <button type="button" class="btn btn-sm btn-outline-success" *ngFor="let role of availableRoles"
                (click)="addRole(role)" [disabled]="loadingRole !== null">
          <span *ngIf="loadingRole === role" class="spinner-border spinner-border-sm"></span>
          <span *ngIf="loadingRole !== role">+ {{ label(role) }}</span>
        </button>
      </div>

      <small class="d-block text-muted mt-3" *ngIf="canEdit">
        <i class="fa fa-info-circle"></i> Pris en compte à la prochaine connexion de l'utilisateur.
      </small>
    </ng-container>
</div>
